export const SET_NEW_PASSWORD_FORM_TITLE_LEAD = 'Reset';
export const SET_NEW_PASSWORD_FORM_TITLE_TAIL = 'Password';

export const SET_NEW_PASSWORD_INVALID_LINK_ERROR
  = 'This password reset link is no longer valid. Request a new reset email to continue.';
export const SET_NEW_PASSWORD_EXPIRED_LINK_ERROR
  = 'This password reset link is no longer valid or has expired. Request a new reset email to continue.';
export const SET_NEW_PASSWORD_UPDATE_ERROR = 'Unable to update your password right now. Please try again later.';
export const SET_NEW_PASSWORD_LINK_ERROR_TITLE = 'Password reset failed';
export const SET_NEW_PASSWORD_REQUEST_NEW_LINK_LABEL = 'Request new reset email';
export const SET_NEW_PASSWORD_TITLE_STANDARD = 'Password updated';
export const SET_NEW_PASSWORD_SUBMIT_LABEL = 'Save password';
export const SET_NEW_PASSWORD_REQUIREMENTS_LABEL = 'Your new password must contain:';
export const SET_NEW_PASSWORD_LABEL = 'New password';
export const SET_NEW_PASSWORD_PLACEHOLDER = '***************';
export const SET_NEW_PASSWORD_REQUIRED_ERROR = 'Enter your new password.';
export const SET_NEW_PASSWORD_CONFIRMATION_LABEL = 'Confirm password';
export const SET_NEW_PASSWORD_CONFIRMATION_PLACEHOLDER = '***************';
export const SET_NEW_PASSWORD_CONFIRMATION_REQUIRED_ERROR = 'Confirm your new password.';
